import { NEWS_GMAIL_SEND_SCOPE_BUNDLE } from "./newsJobError";
import { RECEIPT_SCOPE_BUNDLE } from "./receipt";

export const GOOGLE_SCOPE_BUNDLES = {
  receipt: RECEIPT_SCOPE_BUNDLE,
  news: NEWS_GMAIL_SEND_SCOPE_BUNDLE,
  bundle: "bundle_base" as const,
} as const;

export type GoogleScopeBundle =
  (typeof GOOGLE_SCOPE_BUNDLES)[keyof typeof GOOGLE_SCOPE_BUNDLES];

export type GoogleLinkMode = "single" | "selector" | "all";

export type GoogleIndividualScopeBundle =
  | typeof GOOGLE_SCOPE_BUNDLES.receipt
  | typeof GOOGLE_SCOPE_BUNDLES.news;

export type GoogleScopeGrantedMap = Record<GoogleIndividualScopeBundle, boolean>;

export type GoogleIntegrationAggregateState = "none" | "partial" | "full";

export const GOOGLE_SCOPE_BUNDLES_FOR_ALL: GoogleIndividualScopeBundle[] = [
  GOOGLE_SCOPE_BUNDLES.receipt,
  GOOGLE_SCOPE_BUNDLES.news,
];

export function createDefaultGoogleScopeGrantedMap(): GoogleScopeGrantedMap {
  return {
    [GOOGLE_SCOPE_BUNDLES.receipt]: false,
    [GOOGLE_SCOPE_BUNDLES.news]: false,
  };
}

export function isGoogleScopeBundle(value: unknown): value is GoogleScopeBundle {
  return (
    value === GOOGLE_SCOPE_BUNDLES.receipt ||
    value === GOOGLE_SCOPE_BUNDLES.news ||
    value === GOOGLE_SCOPE_BUNDLES.bundle
  );
}

export function isGoogleLinkMode(value: unknown): value is GoogleLinkMode {
  return value === "single" || value === "selector" || value === "all";
}

export function getGoogleScopeBundleLabel(scopeBundle: GoogleScopeBundle): string {
  if (scopeBundle === GOOGLE_SCOPE_BUNDLES.news) return "ニュース配信（Gmail）";
  if (scopeBundle === GOOGLE_SCOPE_BUNDLES.bundle) return "まとめて連携（領収書保存、ニュース配信）";
  return "領収書保存（Drive / Sheets）";
}

export function resolveGoogleIntegrationAggregateState(
  scopeGrantedMap: GoogleScopeGrantedMap
): GoogleIntegrationAggregateState {
  const grantedCount = GOOGLE_SCOPE_BUNDLES_FOR_ALL.filter((scopeBundle) => scopeGrantedMap[scopeBundle]).length;

  if (grantedCount <= 0) return "none";
  if (grantedCount >= GOOGLE_SCOPE_BUNDLES_FOR_ALL.length) return "full";
  return "partial";
}

export function getGoogleIntegrationAggregateStatusLabel(
  aggregateState: GoogleIntegrationAggregateState
): string {
  if (aggregateState === "full") return "全て連携";
  if (aggregateState === "partial") return "一部連携";
  return "未連携";
}

export function getGoogleIntegrationAggregateStatusDescription(
  aggregateState: GoogleIntegrationAggregateState
): string {
  if (aggregateState === "full") {
    return "ニュース配信と領収書保存に必要なGoogle連携が完了しています。";
  }
  if (aggregateState === "partial") {
    return "ニュース配信または領収書保存のどちらか一方のみ連携済みです。";
  }
  return "ニュース配信と領収書保存のGoogle連携が未完了です。";
}

export function resolveNextGoogleScopeBundleForAllConsent(
  scopeGrantedMap: GoogleScopeGrantedMap
): GoogleScopeBundle | null {
  for (const scopeBundle of GOOGLE_SCOPE_BUNDLES_FOR_ALL) {
    if (!scopeGrantedMap[scopeBundle]) {
      return scopeBundle;
    }
  }
  return null;
}
